module.exports = __webpack_public_path__ + "static/media/icon_alert-bofa.98d4b006.svg";